import { createAction, props } from "@ngrx/store";
import { ResetPassword } from "../../models/reset-password";

export const findResetPasswordAct = createAction('findResetPasswordEffect', props<{ id: number }>());
export const loadResetPasswordByIdAct = createAction('loadResetPasswordByIdEffect', props<{ resetPassword: ResetPassword }>());

export const findResetPasswordTokendAct = createAction('findResetPasswordTokenEffect', props<{ token: string }>());
export const loadResetPasswordByTokenAct = createAction('loadResetPasswordByTokenEffect', props<{ resetPassword: ResetPassword }>());

export const saveResetPasswordAct = createAction('saveResetPasswordEffect', props<{ resetPasswordNew: ResetPassword }>());
export const saveSuccessResetPasswordaAct = createAction('saveSuccessResetPasswordEffect', props<{ resetPasswordNew: ResetPassword }>());

export const updateResetPasswordAct = createAction('updateResetPasswordEffect', props<{ resetPasswordUpdated: ResetPassword }>());
export const updateSuccessResetPasswordAct = createAction('updateSuccessResetPasswordEffect', props<{ resetPasswordUpdated: ResetPassword }>());

export const setViolationsResetPasswordAct = createAction('setViolationsResetPasswordEffect', props<{ resetPasswordForm: ResetPassword, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>());
export const showMsgSuccessAct = createAction('showMsgSuccessEffect', props<{ msg: any }>());